import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import { ColorSchemeScript, MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import App from './App';
import aviaryTheme from './theme/aviaryTheme';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import './index.css';

const DEV_NO_AUTH = process.env.REACT_APP_DEV_NO_AUTH === 'true';

const root = ReactDOM.createRoot(document.getElementById('root'));

const tree = DEV_NO_AUTH ? (
  <App />
) : (
  <Auth0Provider
    domain={process.env.REACT_APP_AUTH0_DOMAIN}
    clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
    cacheLocation="localstorage"
    useRefreshTokens={true}
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      scope: 'openid profile email offline_access',
    }}
  >
    <App />
  </Auth0Provider>
);

root.render(
  <React.StrictMode>
    <ColorSchemeScript defaultColorScheme="light" />
    <MantineProvider theme={aviaryTheme} defaultColorScheme="light" forceColorScheme="light">
      <Notifications />
      {tree}
    </MantineProvider>
  </React.StrictMode>
);
